// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Dropdown_dropdown__2pqiv","selectedItem":"Dropdown_selectedItem__2psvv","icon":"Dropdown_icon__21i9d","groups":"Dropdown_groups__171nO"};